export const getSecurityDepositApi = (params, query) => {
    const queryString = new URLSearchParams(query).toString();
    return `lease/${params?.leaseSlug}/security-deposit${queryString ? `?${queryString}` : ""}`;
};

export const addSecurityDepositApi = (params) => {
    return `lease/${params?.leaseSlug}/security-deposit`;
};

export const updateSecurityDepositApi = (params) => {
    return `lease/${params?.leaseSlug}/security-deposit/${params?.slug}`;
};

export const deleteSecurityDepositApi = (params) => {
    return `lease/${params?.leaseSlug}/security-deposit`;
};

export const getSecurityAgainstDropApi = () => {
    return `security-deposit-against?pagination=false`;
};

export const addcashNonCashApi = (params) => {
    return `lease/${params?.leaseSlug}/security-deposit/${params?.slug}/transactions`;
};
export const updatecashNonCashApi = (params) => {
    return `lease/${params?.leaseSlug}/security-deposit/${params?.slug}/transactions/${params?.txnSlug}`;
};
export const getSecurityDepositConfig = (params, query) => {
    return `lease/${params?.leaseSlug}/security-deposit/config`;
};
export const updateSDConfigApi = (params, query) => {
    return `lease/${params?.leaseSlug}/security-deposit/config`;
};
export const deleteTxnApi = (params) => {
    return `lease/${params?.leaseSlug}/security-deposit/${params?.slug}/transactions`;
}
export const cashTxnUploadApi = (slug) => {
    return `lease/security-deposit-transaction/${slug}/attachments`;
}
export const nonCashTxnUploadApi = (slug) => {
    return `lease/security-deposit-transaction/${slug}/attachments`;
}
export const getCurrencyApi = () => {
    return `/console/currency/`;
}
// cash TXN api used for sorting
export const getCashTxnApi = (params, query) => {
    const queryString = new URLSearchParams(query).toString();
    return `lease/${params?.leaseSlug}/security-deposit/${params?.slug}/transactions${queryString ? `?${queryString}` : ''}`;
};

export const sdUploadApi = (sd_slug) => {
    return `/get-pre-signed-url/security_deposit/${sd_slug}`;
};

export const sdAttachmentMetaData=(attachments_slug)=>{
    return `update-attachment-metadata/security_deposit/${attachments_slug}`
}

export const sdTUploadApi = (sdt_slug) => {
    return `/get-pre-signed-url/security_deposit_transaction/${sdt_slug}`;
};

export const sdTAttachmentMetaData=(attachments_slug)=>{
    return `update-attachment-metadata/security_deposit_transaction/${attachments_slug}`
}

// Get Security Deposit invoice
export const getSdInvoiceApi = (params) => {
    return `security-deposit/init?security_deposit_id=${params}`;   
};




